import { Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import { tokens } from 'ComponentLibrary'

const COLUMN_WIDTH = '560px'

export const SectionCard = styled(Stack)(() => ({
    padding: tokens.SizingSpacing300,
    borderRadius: tokens.SizingCornerM,
    border: `${tokens.SizingBorderS} solid ${tokens.ColorBorderDefault}`,
    backgroundColor: tokens.ColorSurfaceDefault,
    gap: tokens.SizingSpacing150,
}))

export const TopSectionCard = styled(SectionCard)(() => ({
    width: '100%',
}))

export const ContentRow = styled(Stack)(() => ({
    flexDirection: 'row',
    gap: tokens.SizingSpacing300,
    width: '100%',
    justifyContent: 'center',
}))

export const ContentColumn = styled(SectionCard)(() => ({
    flex: `0 0 ${COLUMN_WIDTH}`,
    width: COLUMN_WIDTH,
    minWidth: COLUMN_WIDTH,
    minHeight: '320px',
    overflow: 'visible',
}))

export const PdfContentColumn = styled(ContentColumn)(() => ({
    padding: tokens.SizingSpacing150,
    alignSelf: 'flex-start',
    minHeight: 'auto',
    position: 'sticky',
    top: tokens.SizingSpacing300,
    zIndex: 0,
}))

export const HeaderBar = styled('div')(() => ({
    width: '100%',
    paddingBottom: tokens.SizingSpacing100,
    marginBottom: tokens.SizingSpacing150,
    borderBottom: `${tokens.SizingBorderS} solid ${tokens.ColorBorderDefault}`,
}))

export const KpiTableContainer = styled(Stack)(() => ({
    width: '100%',
    overflowX: 'auto',
    position: 'relative',
    minHeight: '200px', // ensure space for centered loading overlay
}))
